// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"desktop-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M2 4H22V15H2V4Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M2 15V18H22V15H2Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M12 18V21M2 15H22M9 21H15M2 4H22V18H2V4Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Desktop1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'desktop-1',
    ref,
    icon: element,
  },
));

Desktop1Icon.displayName = 'Desktop1Icon';

export default Desktop1Icon;
